import script from "./NetworkChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./NetworkChart.vue?vue&type=script&setup=true&lang=ts"

import "./NetworkChart.vue?vue&type=style&index=0&id=1afd7a12&lang=css"

const __exports__ = script;

export default __exports__